/// <reference path="../../../node_modules/sweetalert2/sweetalert2.d.ts" />
import Swal from "sweetalert2";
import "jquery";

var xhrNumber = 0;
export default function init() {
    
    window.addEventListener("load", function () {
        $("#documenttypefilter, #documentlanguagefilter").on("change", function () {
            search();
        });

        searchTypeDropdownEvent();
        initAccordion();
    });

    window.addEventListener("resize", function () {
        searchTypeDropdownEvent();
    });

    function search() {
        let documentType = $("#documenttypefilter").val();
        let documentLanguage = $("#documentlanguagefilter").val();
        let language = $("#hiddenLanguageCode").val();

        $("#documentsPageLoader").removeClass("d-none");

        $("#productDocs_js").fadeOut();

        // Used for just render the last ajax call
        let seqNumber = ++xhrNumber;

        $.get("/enersysproduct/documentsearch/", {
            pageId: $("#CurrentProduct_ContentGuid").val(),
            documentType: documentType,
            documentLanguage: documentLanguage,
            language: language,
        })
            .done(function (data) {
                $("#productDocs_js").html(data).hide().fadeIn();
            })
            .fail(function (error) {
                if (xhrNumber === seqNumber) {
                    Swal.fire("Oops...", error.statusText, "error");
                    $("#productDocs_js").fadeIn();
                }
            })
            .always(function () {
                if (xhrNumber === seqNumber) {
                    $("#documentsPageLoader").addClass("d-none");
                }
            });
    }

    function searchTypeDropdownEvent(){
        if (window.innerWidth < 767.98) {
            $('#js-select-box').off("change").on("change", function () {
                let dropdown = $('#js-select-box').val();
                $('.tab').hide();
                $('#' + "" + dropdown).show();
            });
        }
    }


    function initAccordion() {
        const accordion = document.querySelector('.model-product-accordion');
        if (!accordion) {
            return;
        }

        const labels = accordion.querySelectorAll<HTMLElement>('.accordion__wrapper > .accordion__header');
        const contents = accordion.querySelectorAll<HTMLElement>('.accordion__wrapper > .accordion__content');

        labels.forEach((label, index) => {
            const content = contents[index];
            content.style.display = 'none';

            // Move content to be after the label
            if (label.parentNode) {
                label.parentNode.insertBefore(content, label.nextSibling);
            }


            // Click event
            label.addEventListener('click', function (event) {
                event.preventDefault();
                toggleAccordion(index);
            });

            // Keyboard accessibility
            label.addEventListener('keydown', function (event) {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    toggleAccordion(index);
                } else if (event.key === 'ArrowDown') {
                    event.preventDefault();
                    const next = (index + 1) % labels.length;
                    labels[next].focus();
                } else if (event.key === 'ArrowUp') {
                    event.preventDefault();
                    const prev = (index - 1 + labels.length) % labels.length;
                    labels[prev].focus();
                }
            });
        });

        function toggleAccordion(index: number) {
            const label = labels[index];
            const content = contents[index];
            const isExpanded = label.getAttribute('aria-expanded') === 'true';

            if (isExpanded) {
                label.setAttribute('aria-expanded', 'false');
                content.style.display = 'none';
                return;
            }

            // Open the clicked section
            label.setAttribute('aria-expanded', 'true');
            if (content.id === 'accordion-tabOne') {
                content.style.display = 'flex';
            } else {
                content.style.display = 'block';
            }
        }

        // Set the first tab to be expanded by default
        if (labels.length > 0) {
            const firstLabel = labels[0];
            const firstContent = contents[0];
            const radio = accordion.querySelector<HTMLInputElement>('#' + firstLabel.getAttribute('for'));

            if (radio && radio.checked) {
                firstLabel.setAttribute('aria-expanded', 'true');
                if (firstContent.id === 'accordion-tabOne') {
                    firstContent.style.display = 'flex';
                } else {
                    firstContent.style.display = 'block';
                }
            }
        }

    }

}
init();